//----------------------------------------------------
// Translate `update_state` strings coming from the AI
// into front-end actions.  Now supports route refresh.
//----------------------------------------------------

import { listMarkets } from 'store/actions/marketsActions';
import { setAiLabelFilter } from 'store/actions/appActions';

export default function routeUpdateState(flag, dispatch, clientId, router) {
  if (!flag) return;                       // "", null, undefined  ->  no-op

  // 1) Refresh a specific note detail
  if (typeof flag === 'string' && flag.startsWith('activity_note:')) {
    const id = Number(flag.split(':')[1]);
    window.dispatchEvent(new CustomEvent('refresh-activity-note', { detail: { id } }));
    return;
  }

  // 2) Launch AI label filter dialog
  //    update_state: 'launch_label_filter:{"mode":"new_namespace",...}'
  if (typeof flag === 'string' && flag.startsWith('launch_label_filter:')) {
    try {
      const payload = JSON.parse(flag.slice('launch_label_filter:'.length));
      dispatch(setAiLabelFilter({ ...payload, open: true }));
      if (router?.navigate) router.navigate('/labels');
    } catch (e) {
      console.error('[routeUpdateState] Failed to parse launch_label_filter payload:', e);
    }
    return;
  }

  // 3) Refine label filter — update criteria only
  if (typeof flag === 'string' && flag.startsWith('refine_label_filter:')) {
    try {
      const criteria = JSON.parse(flag.slice('refine_label_filter:'.length));
      dispatch(setAiLabelFilter({ criteria }));
    } catch (e) {
      console.error('[routeUpdateState] Failed to parse refine_label_filter payload:', e);
    }
    return;
  }

  // 4) Save label filter — trigger save from chatbot
  if (flag === 'save_label_filter') {
    dispatch(setAiLabelFilter({ saveTrigger: true }));
    return;
  }

  /* ------------------------------------------------------------------
   * Registry : map back-end strings  →  front-end side-effects
   * ------------------------------------------------------------------ */
  const registry = {
    markets: () => dispatch(listMarkets(clientId, { force: true })),
    activity_notes: () =>
      window.dispatchEvent(new Event('refresh-activity-notes')),
    '': () => {},
    routermeunused: () => {
      const nav = router?.navigate;
      if (typeof nav === 'function') {
        nav(0);
      } else {
        window.location.reload();
      }
    },
  };

  const fn = registry[flag];
  if (typeof fn === 'function') fn();
}